// extracted by mini-css-extract-plugin
export default {"BuildListCollapseHeader":"CollapseHeader_BuildListCollapseHeader__cyNAR","TitleContainer":"CollapseHeader_TitleContainer__5hRnA"};